import {
  format as dateFnsFormat,
  formatISO as dateFnsFormatISO,
} from "date-fns";
import { ja } from "date-fns/locale";

export const format = (
  date: Date | number,
  format: string,
  options?: {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: number;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
  },
): string => {
  const mergedOptions = options?.locale
    ? options
    : {
        ...options,
        locale: ja,
      };
  return dateFnsFormat(date, format, mergedOptions);
};

export const formatISO = (
  date: Date | number,
  options?: {
    format?: "extended" | "basic";
    representation?: "complete" | "date" | "time";
  },
): string => {
  return dateFnsFormatISO(date, options);
};

export const formatDateRange = (start: Date, end: Date): string => {
  return `${format(start, "yyyy/MM/dd(E) HH:mm", {
    locale: ja,
  })} ~ ${format(end, "HH:mm")}`;
};

export const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());

export const parseValidDate = (
  dateText: string | undefined,
): Date | undefined => {
  try {
    const date = dateText ? new Date(dateText) : undefined;
    if (!date) {
      return undefined;
    }

    if (isInvalidDate(date)) {
      return undefined;
    }

    return date;
  } catch (e) {
    return undefined;
  }
};

export const DateFormat = {
  DEFAULT: "yyyy-MM-dd",
  DEFAULT_SLASH: "yyyy/MM/dd",
  FULL: "yyyy/MM/dd HH:mm",
  FULL_DASH: "yyyy-MM-dd HH:mm",
  FULL_MINUTES: "yyyy/MM/dd HH:mm:ss",
  HOURS_MINUTES: "HH:mm",
  MONTH_DATE_JP: "yyyy年MM月",
  yyyy_MM: "yyyy-MM",
  "yyyy/MM/dd": "yyyy-MM-dd",
  DATE_JP: "yyyy年MM月dd日",
  DATE_JP_FULL: "yyyy年MM月dd日 HH:mm:ss",
  SLASH_JP: "yyyy/MM/dd（E）",
};